<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="活动">
                  <el-input  v-model="queryForm.activityId"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopActivityBannerList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopActivityBanner"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editShopActivityBanner(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopActivityBanner(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
<!--        <span-->
<!--          title="搜索"-->
<!--          class="icon-box"-->
<!--          @click="search"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <Search />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshShopActivityBannerList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopActivityBannerList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="bannerPic"
        label="图片地址"
      >
          <template slot-scope="scop">
              <el-image
                  @click='updateSrcList(scop.row.bannerPic)'
                  style="width: 30px; height: 30px"
                  :src="scop.row.bannerPic"
                  :preview-src-list="srcList"
              ></el-image>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="bannerLink"
        label="图片链接"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="activityId"-->
<!--        label="活动"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopActivityBanner(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editShopActivityBanner(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteShopActivityBanner(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopActivityBannerStates[shopActivityBannerState]"
      :visible.sync="showDialog"
      width="400px"
      :append-to-body="true"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopActivityBanner"
          ref="shopActivityBannerForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="图片地址"
            prop="bannerPic"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopActivityBanner.bannerPic"-->
<!--              :disabled="shopActivityBannerState == 'check'"-->
<!--            ></el-input>-->
              <el-upload
                  action=""
                  :disabled="shopActivityBannerState == 'check'"
                  class="avatar-uploader"
                  :show-file-list="false"
                  :http-request="uploadAvatar"
                  style="width: 200px"
              >
                  <img
                      v-if="shopActivityBanner.bannerPic"
                      :src="shopActivityBanner.bannerPic"
                      class="avatar"
                  />
                  <i
                      v-else
                      class="el-icon-plus avatar-uploader-icon"
                  ></i>
              </el-upload>
          </el-form-item>
          <el-form-item
            label="图片链接"
            prop="bannerLink"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopActivityBanner.bannerLink"
              :disabled="shopActivityBannerState == 'check'"
            ></el-input>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="活动"-->
<!--            prop="activityId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopActivityBanner.activityId"-->
<!--              :disabled="shopActivityBannerState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="排序"
            prop="sort"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopActivityBanner.sort"-->
<!--              :disabled="shopActivityBannerState == 'check'"-->
<!--            ></el-input>-->
              <el-input-number
                  style="width: 200px"
                  :disabled="shopActivityBannerState == 'check'"
                  v-model="shopActivityBanner.sort"
                  size="small"
                  label=""
                  :min="1"
                  :max="100000"
                  :step="1"
                  :controls="true"
                  controls-position="both"
              >
              </el-input-number>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopActivityBannerState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopActivityBannerList();
                    this.getShopActivityBannerList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopActivityBannerList();
                    this.getShopActivityBannerList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     bannerPic: '', //图片地址
                     bannerLink: '', //图片链接
                     activityId: '', //活动
                     sort: '', //排序
                },
                srcList: [''],
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopActivityBannerState: 'add',
                shopActivityBannerStates: {
                    add: '新建活动banner',
                    check: '查看活动banner',
                    edit: '修改活动banner'
                },

                multipleSelection: [],
                shopActivityBannerList: [],
                shopActivityBanner: {
                    id: '', //
                    bannerPic: '', //图片地址
                    bannerLink: '', //图片链接
                    activityId: '', //活动
                    sort: '', //排序
                },
                btnLoading: false,

                rules: {
                    bannerPic: [{ required: true, message: '图片地址不能为空', trigger: 'blur' }],
                    bannerLink: [{ required: true, message: '图片链接不能为空', trigger: 'blur' }],
                    activityId: [{ required: true, message: '活动不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {

        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            uploadAvatar(params) {
                console.log({ params });
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg'];
                if (!types.includes(file.type)) {
                    this.$message({
                        message: '只能上传图片格式的文件，png.jpg或者jpeg',
                        type: 'error',
                        showClose: true,
                        duration: 2000
                    });
                    return;
                }
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                upload(`/mpp/image/upload`, formData).then((res) => {
                    console.log({ res });
                    if (res.success) {
                        this.shopActivityBanner.bannerPic = res.url;
                    }
                });
            },
            updateSrcList(src) {
                this.srcList[0] = src;
            },
            init(id){
                this.resetShopActivityBannerList();
                this.queryForm.activityId = id;
                this.shopActivityBanner.activityId = id;
                this.getShopActivityBannerList();
            },
            resetShopActivityBannerList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopActivityBannerList = [];
            },
            resetDialog() {
                this.shopActivityBannerState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      bannerPic: '', //图片地址
                      bannerLink: '', //图片链接
                      activityId: this.queryForm.activityId, //活动
                      sort: '', //排序
                };
                this.getShopActivityBannerList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopActivityBanner = {
                      id: '', //
                      bannerPic: '', //图片地址
                      bannerLink: '', //图片链接
                      activityId: this.shopActivityBanner.activityId, //活动
                      sort: '', //排序
                };
            },
            submitForm() {
                if (this.shopActivityBannerState == 'add') {
                    this.$refs.shopActivityBannerForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/activitybanner/add`,{ ...this.shopActivityBanner }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopActivityBannerList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopActivityBannerState == 'edit') {
                    this.$refs.shopActivityBannerForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/activitybanner/edit`,{ ...this.shopActivityBanner }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopActivityBannerList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopActivityBanner() {
                this.showDialog = true;
                this.shopActivityBannerState = 'add';
            },
            checkShopActivityBanner(shopActivityBannerId) {
                console.log(shopActivityBannerId);
                this.currentShopActivityBannerId = shopActivityBannerId;

                this.getShopActivityBannerById();
                this.showDialog = true;
                this.shopActivityBannerState = 'check';
            },
            editShopActivityBanner(shopActivityBannerId) {
                console.log('shopActivityBanner', shopActivityBannerId);
                if (shopActivityBannerId) {
                    this.currentShopActivityBannerId = shopActivityBannerId;
                    this.getShopActivityBannerById();
                } else {
                    this.shopActivityBanner = { ...this.shopActivityBanner, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopActivityBannerState = 'edit';
            },
            deleteShopActivityBanner(shopActivityBannerId) {
                let ids = '';
                if (shopActivityBannerId) {
                    ids = shopActivityBannerId;
                } else {
                    ids = this.multipleSelection.map((shopActivityBanner) => shopActivityBanner.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/activitybanner/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopActivityBannerList();
                                this.getShopActivityBannerList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopActivityBannerList() {
                this.resetShopActivityBannerList();
                this.getShopActivityBannerList();
            },
            getShopActivityBannerList(query = {}) {
                this.loading = true;
                get(`/shop/activitybanner/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopActivityBannerList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopActivityBannerById() {
                get(`/shop/activitybanner/get`,{ id: this.currentShopActivityBannerId }).then((res) =>{
                    if(res.success){
                      this.shopActivityBanner = { ...this.shopActivityBanner, ...res.shopActivityBanner };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopActivityBannerList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/activitybanner/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/activitybanner/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/activitybanner/importData`,formData);
              this.refreshShopActivityBannerList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopActivityBannerList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopActivityBannerList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
</style>